export const SET_NEWS_CONTENT = 'SET_NEWS_CONTENT';
